import { useArquivosAnexadosNoProntuarioQuery } from 'graphql/hooks.generated'
import { useConfiguracoes } from 'hooks/configuracoes'
import { useMemo } from 'react'
import { Route, useHistory, useRouteMatch } from 'react-router'
import { isEmpty } from 'util/checks'

import { convertQueryToAnexoArquivoRowModel } from '../../objetivo/anexo-arquivos/converter-anexoArquivos'
import { sortAnexoArquivos } from '../../objetivo/anexo-arquivos/utils/sortAnexoArquivos'
import { ProntuarioCard } from '../ProntuarioCard'
import { AnexoArquivosCard } from './AnexoArquivosCard'
import { AnexoArquivosListagemModal } from './AnexoArquivosListagemModal'

interface AnexoArquivosSectionProps {
  prontuarioId: ID
}

const ANEXO_ARQUIVOS_MODAL_ROUTE = 'anexo-arquivos'
const MAX_ULTIMOS_ANEXOS = 3

export function AnexoArquivosSection(props: Readonly<AnexoArquivosSectionProps>) {
  const { prontuarioId } = props
  const history = useHistory()
  const match = useRouteMatch()
  const modalUrl = `${match.path}/${ANEXO_ARQUIVOS_MODAL_ROUTE}`

  const {
    configuracoes: { anexoArquivosEnabled },
  } = useConfiguracoes()

  const { data, loading } = useArquivosAnexadosNoProntuarioQuery({
    variables: { prontuarioId },
  })

  const arquivos = useMemo(() => {
    return convertQueryToAnexoArquivoRowModel(data?.arquivosAnexadosNoProntuario ?? [])
  }, [data?.arquivosAnexadosNoProntuario])

  const ultimosArquivos = useMemo(() => {
    return sortAnexoArquivos(arquivos, ['-data']).slice(0, MAX_ULTIMOS_ANEXOS)
  }, [arquivos])

  const hasArquivos = !isEmpty(arquivos)
  const renderAnexos = anexoArquivosEnabled || hasArquivos

  if (!renderAnexos) {
    return null
  }

  const handleClick = () => {
    history.push(`${match.url}/${ANEXO_ARQUIVOS_MODAL_ROUTE}`)
  }

  return (
    <>
      <Route
        path={modalUrl}
        render={() => <AnexoArquivosListagemModal onClose={() => history.goBack()} arquivos={arquivos} />}
      />

      <ProntuarioCard
        title='Anexo de arquivo'
        subTitle={hasArquivos ? `Últimos ${MAX_ULTIMOS_ANEXOS} anexos` : undefined}
        tooltip={hasArquivos ? 'Ver arquivos anexados' : 'Nenhum anexo de arquivo registrado'}
        onClick={hasArquivos ? handleClick : undefined}
        dataTestId='ProntuarioCard.AnexoArquivos'
      >
        <AnexoArquivosCard ultimosArquivos={ultimosArquivos} loading={loading} canRender={hasArquivos} />
      </ProntuarioCard>
    </>
  )
}
